export const questions = [
  {
    id: 1,
    text: "当你遇到一个全新的复杂问题时，你的第一反应是？",
    options: [
      { label: "仔细分析所有细节，寻找逻辑规律", scores: { owl: 2, fox: 1 } },
      { label: "快速尝试几种不同方法，看看哪个有效", scores: { leopard: 2, bird: 1 } },
      { label: "参考类似问题的成功经验", scores: { ant: 2, wolf: 1 } },
      { label: "寻求他人意见或合作解决", scores: { dolphin: 2, panda: 1 } },
    ],
  },
  {
    id: 2,
    text: "周末你更愿意如何度过闲暇时间？",
    options: [
      { label: "学习新技能或阅读深度书籍", scores: { owl: 2 } },
      { label: "尝试从未体验过的活动或旅行", scores: { bird: 2, squirrel: 1 } },
      { label: "完成未完成的工作或整理房间", scores: { ant: 2, wolf: 1 } },
      { label: "与朋友聚会或参加社交活动", scores: { dolphin: 2, lion: 1 } },
    ],
  },
  {
    id: 3,
    text: "面对一个抽象的艺术作品，你通常会？",
    options: [
      { label: "深入思考象征意义和作者意图", scores: { owl: 2, cat: 1 } },
      { label: "关注自己的直觉感受和情绪反应", scores: { cat: 2, bird: 1 } },
      { label: "分析其技术实现和视觉效果", scores: { fox: 2, leopard: 1 } },
      { label: "更偏好具体、实用的作品", scores: { ant: 2, wolf: 1 } },
    ],
  },
  {
    id: 4,
    text: "接到有明确截止日期的任务时，你通常会？",
    options: [
      { label: "立即制定详细计划并严格执行", scores: { ant: 2, lion: 1 } },
      { label: "先收集信息，再制定最佳策略", scores: { fox: 2, owl: 1 } },
      { label: "设定关键节点，保持灵活性", scores: { bird: 2, leopard: 1 } },
      { label: "与团队合作，分工完成任务", scores: { dolphin: 2, panda: 1 } },
    ],
  },
  {
    id: 5,
    text: "你的个人物品和工作空间通常处于什么状态？",
    options: [
      { label: "井井有条，每样东西都有固定位置", scores: { ant: 2, wolf: 1 } },
      { label: "看起来有些乱，但自己知道东西在哪", scores: { fox: 2, bird: 1 } },
      { label: "根据当前项目需要随时调整", scores: { leopard: 2, lion: 1 } },
      { label: "整洁与否取决于心情", scores: { cat: 2, squirrel: 1 } },
    ],
  },
  {
    id: 6,
    text: "面对枯燥但必要的重复性工作时，你会？",
    options: [
      { label: "建立标准化流程，高效完成", scores: { ant: 2, wolf: 1 } },
      { label: "寻找方法让工作变得有趣", scores: { fox: 2, bird: 1 } },
      { label: "尽快完成，做更有趣的任务", scores: { leopard: 2, squirrel: 1 } },
      { label: "需要外部激励或监督", scores: { dolphin: 2, dog: 1 } },
    ],
  },
  {
    id: 7,
    text: "在大型社交场合中，你通常感到？",
    options: [
      { label: "充满能量，乐于结识新朋友", scores: { lion: 2, dolphin: 1 } },
      { label: "舒适但更倾向和熟悉的人交流", scores: { panda: 2, dog: 1 } },
      { label: "先观察环境，再选择性互动", scores: { owl: 2, fox: 1 } },
      { label: "会消耗能量，期待早点离开", scores: { cat: 2, bird: 1 } },
    ],
  },
  {
    id: 8,
    text: "当朋友向你倾诉个人问题时，你的第一反应是？",
    options: [
      { label: "认真倾听，提供情感支持", scores: { dog: 2, panda: 1 } },
      { label: "分析问题，寻找解决方案", scores: { owl: 2, fox: 1 } },
      { label: "分享自己的类似经历", scores: { dolphin: 2, squirrel: 1 } },
      { label: "建议先转移注意力", scores: { bird: 2, leopard: 1 } },
    ],
  },
  {
    id: 9,
    text: "团队合作出现分歧时，你通常扮演什么角色？",
    options: [
      { label: "协调各方，寻找共识", scores: { panda: 2, dolphin: 1 } },
      { label: "提出创新方案，打破僵局", scores: { fox: 2, bird: 1 } },
      { label: "坚持正确方向，推动决策", scores: { lion: 2, wolf: 1 } },
      { label: "分析利弊，提供客观建议", scores: { owl: 2, ant: 1 } },
    ],
  },
  {
    id: 10,
    text: "面对重要人生决策时，你更倾向于？",
    options: [
      { label: "收集大量信息，仔细权衡", scores: { owl: 2, ant: 1 } },
      { label: "跟随直觉和内心感受", scores: { cat: 2, bird: 1 } },
      { label: "咨询信任的人", scores: { dog: 2, panda: 1 } },
      { label: "设定标准，符合条件即可", scores: { wolf: 2, lion: 1 } },
    ],
  },
  {
    id: 11,
    text: "尝试有失败风险的新事物时，你内心通常会？",
    options: [
      { label: "很刺激，失败也能学到东西", scores: { bird: 2, fox: 1 } },
      { label: "先做充分准备，降低风险", scores: { ant: 2, owl: 1 } },
      { label: "别人能做到，我也可以", scores: { lion: 2, wolf: 1 } },
      { label: "有点担心，但怕错过机会", scores: { cat: 2, squirrel: 1 } },
    ],
  },
  {
    id: 12,
    text: "计划突然被打乱时，你的情绪反应通常是？",
    options: [
      { label: "轻微不适，但能快速调整", scores: { leopard: 2, bird: 1 } },
      { label: "感到压力，需要时间重新规划", scores: { ant: 2, owl: 1 } },
      { label: "趁机探索新可能", scores: { fox: 2, squirrel: 1 } },
      { label: "明显焦虑，影响后续状态", scores: { cat: 2, dog: 1 } },
    ],
  },
  {
    id: 13,
    text: "你认为成功人生最重要的标志是？",
    options: [
      { label: "持续成长和学习", scores: { owl: 2, bird: 1 } },
      { label: "对家庭和社区有贡献", scores: { dog: 2, panda: 1 } },
      { label: "实现个人目标和抱负", scores: { lion: 2, wolf: 1 } },
      { label: "内心平静和满足", scores: { cat: 2, squirrel: 1 } },
    ],
  },
  {
    id: 14,
    text: "你如何看待规则和传统？",
    options: [
      { label: "尊重规则，但会灵活应用", scores: { fox: 2, bird: 1 } },
      { label: "认真遵守，维护秩序", scores: { ant: 2, wolf: 1 } },
      { label: "质疑不合理之处，推动改进", scores: { lion: 2, owl: 1 } },
      { label: "更关注规则背后的精神", scores: { panda: 2, dog: 1 } },
    ],
  },
  {
    id: 15,
    text: "空闲时间你更愿意？",
    options: [
      { label: "深入钻研一个感兴趣的领域", scores: { owl: 2, fox: 1 } },
      { label: "与亲友共享美好时光", scores: { squirrel: 2, dolphin: 1 } },
      { label: "完成有实际产出的项目", scores: { ant: 2, wolf: 1 } },
      { label: "独自反思或享受宁静", scores: { cat: 2, bird: 1 } },
    ],
  },
  {
    id: 16,
    text: "当面临巨大压力时，你最有效的缓解方式是？",
    options: [
      { label: "制定计划，逐步解决", scores: { ant: 2, lion: 1 } },
      { label: "和信任的人聊一聊", scores: { dog: 2, dolphin: 1 } },
      { label: "做点创作或新鲜活动转移注意", scores: { bird: 2, fox: 1 } },
      { label: "独处整理思绪", scores: { cat: 2, owl: 1 } },
    ],
  },
  {
    id: 17,
    text: "你如何看待自己的错误和失败？",
    options: [
      { label: "把它当学习机会，复盘改进", scores: { owl: 2, fox: 1 } },
      { label: "难免会犯错，不必过度自责", scores: { squirrel: 2, bird: 1 } },
      { label: "要负责并努力弥补", scores: { wolf: 2, ant: 1 } },
      { label: "容易陷入自我批评", scores: { cat: 2, dog: 1 } },
    ],
  },
  {
    id: 18,
    text: "在陌生环境中，你的第一反应是？",
    options: [
      { label: "兴奋探索新环境", scores: { squirrel: 2, bird: 1 } },
      { label: "先观察规则和环境", scores: { owl: 2, leopard: 1 } },
      { label: "先寻找熟悉或安全的元素", scores: { dog: 2, panda: 1 } },
      { label: "会有些不安，需要适应时间", scores: { cat: 2, ant: 1 } },
    ],
  },
  {
    id: 19,
    text: "在团队里，你自然倾向于？",
    options: [
      { label: "组织协调，确保任务完成", scores: { lion: 2, ant: 1 } },
      { label: "提供创意和解决方案", scores: { fox: 2, bird: 1 } },
      { label: "支持成员，维护团队和谐", scores: { panda: 2, dolphin: 1 } },
      { label: "专注自己的专业贡献", scores: { owl: 2, wolf: 1 } },
    ],
  },
  {
    id: 20,
    text: "你如何对待竞争？",
    options: [
      { label: "享受竞争带来的挑战和成长", scores: { lion: 2, leopard: 1 } },
      { label: "更看重合作而非竞争", scores: { panda: 2, dolphin: 1 } },
      { label: "把竞争当成自我检验", scores: { wolf: 2, owl: 1 } },
      { label: "竞争常带来不必要的压力", scores: { cat: 2, dog: 1 } },
    ],
  },
];
